export default "__VITE_ASSET__B7u6HLJC__"